import styled from 'styled-components';
import { colors, fontWeight } from 'utils/variables';
import hexToRGBA from 'utils/hexToRGBA';

export const stateMapper = {
  error: {
    labelColor: colors.error,
    labelBeforeBorder: colors.error,
    inputCheckedLabelAfterBackground: colors.error,
  },
  success: {
    labelColor: colors.success,
    labelBeforeBorder: colors.success,
    inputCheckedLabelAfterBackground: colors.success,
  },
};

export const StyledCheckbox = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
`;

export const StyledLabel = styled.label`
  display: inline-flex;
  width: 100%;
  color: ${({ theme }) => theme.labelColor};
  font-weight: ${fontWeight.light};
  font-size: 1.4rem;
  line-height: 2.4rem;
  margin: 0 0.8rem 0.5rem 0;
  cursor: pointer;
  position: relative;

  &:before {
    content: ' ';
    box-sizing: border-box;
    display: inline-block;
    top: 0;
    left: 0;
    min-height: 2.5rem;
    min-width: 2.5rem;
    max-height: 2.5rem;
    max-width: 2.5rem;
    margin-right: 1.5rem;
    border-radius: 0.3rem;
    border: 0.2rem solid ${({ theme }) => theme.labelBeforeBorder || colors.butter};
  }

  &:hover:before {
    background-color: ${colors.white};
  }

  a {
    display: contents;
    font-weight: ${fontWeight.light};
    color: ${({ theme }) => theme.labelColor || colors.black};

    &:hover {
      color: ${({ theme }) => (theme.labelColor ? hexToRGBA(theme.labelColor, 0.75) : hexToRGBA(colors.black, 0.75))};
    }
  }
`;

export const StyledInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  padding: 0;
  border: 0;

  &:checked ~ label:after {
    content: ' ';
    display: block;
    height: 1.5rem;
    width: 1.5rem;
    border-radius: 0.2rem;
    background-color: ${({ theme }) => theme.inputCheckedLabelAfterBackground};
    position: absolute;
    left: 0.5rem;
    top: 0.5rem;
  }
`;

export const StyledMsgBox = styled.span`
  z-index: 10;
  display: flex;
  position: relative;
  align-items: center;
  font-weight: ${fontWeight.light};
  font-size: 1.2rem;
  cursor: text;
  color: ${colors.error};
  transition: transform 300ms ease, opacity 300ms ease;
  margin: 0 0 0 6rem;
  transform: ${({ children }) => !children && 'translateY(-2rem)'};
  opacity: ${({ children }) => (children ? '1' : '0')};
`;
